export default "__VITE_ASSET__dHQQciMC__"